import { Users, Atom, FileCheck, GraduationCap, FileText, Plane } from 'lucide-react'

export default function StudyAbroadServices() {
  const services = [
    {
      icon: Users,
      title: "On-Ground & Cloud Counselling",
      description: "Get personalized in-person or virtual counselling sessions with our experts."
    },
    {
      icon: Atom,
      title: "AI-Powered Program Selection",
      description: "Receive tailored AI suggestions for programs that align with your career goals."
    },
    {
      icon: FileCheck,
      title: "Express Admissions Services",
      description: "Fast-track your university application and secure an admission in no time."
    },
    {
      icon: GraduationCap,
      title: "Scholarship Guidance",
      description: "Explore global scholarship opportunities and get help with your application."
    },
    {
      icon: FileText,
      title: "Education Loan Assistance",
      description: "Access the best loan rates and get quick approvals through our partners."
    },
    {
      icon: Plane,
      title: "Pre-departure Session",
      description: "Receive expert tips on banking, travel, and settling abroad for a smooth journey."
    }
  ];
  

  return (
    <div className="container mx-auto max-w-screen-lg py-16">
      <div className="space-y-4 mb-12 mx-4">
        {/* <h2 className="text-gray-600 font-medium text-xl">Why ApplicationUni?</h2> */}
        <h1 className="text-2xl md:text-2xl lg:text-5xl notoh font-bold text-gray-900 text-center " >
          Amongst the Largest and Trusted Study Abroad Consultants
        </h1>
      </div>

      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-6 lg:mx-0 mx-4">
        {services.map((service, index) => (
          <div
            key={index}
            className="p-8 rounded-lg border border-gray-100 shadow-sm bg-white hover:shadow-md transition-shadow text-center"
          >
            <service.icon className="w-12 h-12 mb-6 text-gray-600 mx-auto" />
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              {service.title}
            </h3>
            <p className="text-gray-600 leading-relaxed">
              {service.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}

